import React, { FC, useEffect } from 'react';
import { Table } from 'esa-ui-library';
import { PropertyType } from 'esa-ui-library/lib/types';

import styles from './History.module.scss';
import { historyColumns } from './History.const';
import { getRows } from './RowProvider';
import { useStore } from '../../../../../common';

interface HistoryProps {
	data: PropertyType[];
}

const History: FC<HistoryProps> = ({ data }): JSX.Element => {
	const [state, dispatch] = useStore();
	const { historyRows } = state;
	useEffect(() => {
		dispatch('UPDATE_ROWS', getRows(data));
	}, [data]);

	return (
		<section className={`${styles.History}`}>
			<Table titles={historyColumns} data={historyRows} className={styles.Table} rowClassName={styles.Row} />
		</section>
	);
};

export { History };
